import { use, useEffect, useState } from "react";
import Menu from "../../Component/Menu/Menu";
import ModalCrearEvento from "./ModalCrearEvento";
import BarCard from "../../Component/header/BarCard";
import { obtenerEventos } from "../../Servicios/Servicios";
import { useSpinner } from "../../Component/spinner/spinner";
import { FaQrcode } from "react-icons/fa";
import qrCodeImage from '../../assets/image/qr_code_2.png'; // Asegúrate de tener una imagen de código QR si la necesitas
import { useNavigate } from "react-router-dom";
import { QRCode } from "react-qrcode-logo";

function Eventos() {
  
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [Eventos, setEventos] = useState([]);
  const spinner = useSpinner();
  const urlpage = process.env.REACT_APP_PAGE || "https://eventorys.web.app/";
  const [valorQR, setValorQR] = useState("");
  const [showModalqr, setShowModalqr] = useState(false);

  useEffect(() => {
    obtenerEventosData();
  }, []);

  const eventoClick = (evento) => {
    navigate("/Music", { state: { evento } });
  }
  // Abre el modal y actualiza el valor del QR
  const openModalqr = (evento) => {
    // Primero cierra el modal y limpia el valor
    setShowModalqr(false);
    setValorQR("");
    // Luego actualiza el valor y abre el modal en el siguiente ciclo
    setTimeout(() => {
      setValorQR(`${urlpage}BuscarCancion/${evento.id}`);
      console.log("vae ", valorQR);
      setShowModalqr(true);
    }, 0);
  };

  const obtenerEventosData = async () => {
    spinner.show();
    const idEstablecimiento = await localStorage.getItem("idEstablecimiento");
    try {
      if (!idEstablecimiento) {
        console.error("No se encontró el ID del establecimiento en localStorage.");
        spinner.hide();
        return;
      }
      const response = await obtenerEventos();
      if (response.success) {
        setEventos(response.data.resultados);
        spinner.hide();
      } else {
        console.error("Error al obtener eventos:", response.message);
        spinner.hide();
      }
    } catch (error) {
      console.error("Error al obtener eventos:", error);
      spinner.hide();
    }

  }

  return (
    <div >
      {/* <Menu /> */}
      <div >
        {/* <BarCard /> */}
        <div className="flex flex-col p-8">
          <div className="flex justify-between items-center mb-8">
            <h2 className="text-xl text-white">Eventos</h2>
            <button onClick={() => setShowModal(true)} id="botonesEstandar">
              Crear evento
            </button>
          </div>
          { Eventos.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 h-96 overflow-y-auto">
              
              {Eventos.map((evento, index) => (
                <div key={index} className="rounded-lg shadow-md rounded">

                {evento.imagen ? (
                    <img
                      src={evento.imagen}
                      alt="Evento"
                      className="w-full h-40 object-cover rounded-t-xl"
                    />
                  ) : (
                    <div className="w-full h-40 bg-gray-200 flex items-center justify-center text-gray-500 text-sm">
                      Imagen no disponible
                    </div>
                  )}
                  <div className="flex flex-col md:flex-row gap-2 p-1 " id="CuadrosEstandar">
                    <div className="p-1 flex-1">
                      <h3 className="text-[#4F60A8] font-bold  mb-1 cursor-pointer" onClick={()=> eventoClick(evento)}>{evento.nombreEvento}</h3>
                      {/* <p className="text-gray-600 text-sm mb-1">Valor de ingreso: ${evento.valorIngreso}</p> */}
                      {/* <p className="text-gray-600 text-sm mb-1">Fecha: {evento.fecha || "No disponible"}</p> */}
                      {/* <p className="text-gray-600 text-sm mb-1 ">{evento.descripcion || "No disponible"}</p> */}
                      <p className="text-gray-600 text-sm mb-1 text-white">Fecha: {evento.fechaInicio || "No disponible"} - {evento.fechaFin} </p>
                      <p className="text-gray-600 text-sm mb-1 text-white">Horarios: {evento.horarios}</p>
                    </div>

                    {/* Código QR o ícono */}
                    <div className="p-1 flex items-center justify-center">
                      <div className="flex items-center cursor-pointer justify-center w-10 h-10 bg-gray-10 rounded-md"  style={{ backgroundColor: '#4F60A8BA' }}>
                        <img
                          src={qrCodeImage}
                          onClick={()=>openModalqr(evento)}
                          alt="QR Code"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
          <div className="text-center text-gray-400 text-xs mt-32">
            No tienes ningún evento creado todavía
          </div>
          )}
        </div>
      </div>
      {showModal && <ModalCrearEvento onClose={() => setShowModal(false)} obtenerEventosData={obtenerEventosData} />}
      {showModalqr && valorQR && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50" onClick={() => setShowModalqr(false)}>
          <div className="p-4 rounded-lg shadow-lg inline-block relative" id="CuadrosEstandar" style={{display: 'block'}} onClick={(e) => e.stopPropagation()}>
            <button
              onClick={() => setShowModalqr(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-black text-xl text-white"
            >
              x
            </button>
            <h2 className="text-xl font-bold mb-4 text-center text-white">Codigo QR Evento</h2>
            <div className="mt-4">
              <QRCode value={valorQR} fgColor="#293d9aff" size={256} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Eventos;
